export enum carmelTransactionCodes {
  checkingCredit = 22,
  checkingDebt = 27,
}
